module.exports = __webpack_public_path__ + "react/assets/TriggeringModal/TriggerByPushNotificationAssets/PushNotification/mobileAndroid.png";